export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
export const QUARTER_HOUR_IN_MS = 15 * 60 * 1000;
